"use client";

import { useEffect } from "react";
import Link from "next/link";
import bgImg from "@/app/_lib/assets/images/bg-gradient.png";
import { RefreshCw, MessageCircle } from "lucide-react";
import Nav from "./(routes)/components/nav";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <>
      <Nav session={null} />
      <section className="max-w-[1500px] px-3 md:px-[100px] mx-auto flex items-center justify-center min-h-[calc(100vh-100px)]">
        <div className="flex flex-col border-x border-border flex-1 w-full">
          {/* Hero Section */}
          <div
            className="flex flex-col items-center justify-center text-center bg-cover bg-center p-10 md:p-16 text-white min-h-[80vh]"
            style={{ backgroundImage: `url(${bgImg.src})` }}
          >
            <div className="flex flex-col items-center justify-center gap-6">
              <div className="flex flex-col items-center justify-center gap-3">
                <h1 className="text-[56px] md:text-[64px] font-bold leading-none tracking-tight">
                  Oops! Something went wrong.
                </h1>
                <p className="max-w-[480px] text-center text-sm md:text-base text-gray-200 leading-relaxed">
                  We encountered an unexpected error. Our team has been
                  notified. You can try again or reach out for support.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 mt-6">
                <button
                  onClick={() => reset()}
                  className="inline-flex items-center justify-center gap-2 bg-white text-black font-medium px-6 py-3 rounded-[8px] hover:bg-gray-100 transition"
                >
                  <RefreshCw className="w-5 h-5" />
                  Try Again
                </button>
                <Link
                  href="/connect"
                  className="inline-flex items-center justify-center gap-2 border border-white text-white px-6 py-3 rounded-[8px] hover:bg-white hover:text-black transition"
                >
                  <MessageCircle className="w-5 h-5" />
                  Contact Support
                </Link>
              </div>
            </div>

            {/* <div className="mt-12 opacity-80">
              <Image
                src="/bex.png"
                alt="Busyexpand Logo"
                width={120}
                height={40}
                className="mx-auto invert brightness-0"
              />
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
}
